import CascadeReelGroup from "../../../vendor_core/core/src/views/CascadeReelGroup";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import GameModel from "../../../vendor_core/core/src/model/GameModel";
import GameEvents from "../../../vendor_core/core/src/const/GameEvents";
import Configs from "../../../vendor_core/src/vendorConfigs/Configs";
import BURReelSymbol from "./BURReelSymbol";
import BURSpinModel from "../models/BURSpinModel";
import { CoinColor, PointLike } from "../types/BURGameTypes";
import { IAnimationStateListener } from "pixi-spine";
import BURFeatureModel from "../models/BURFeatureModel";
import SpineAnimation from "../../../vendor_core/core/src/views/SpineAnimation";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import { Tween } from "../../../vendor_core/core/src/Tween";
import BURReelsModel from "../models/BURReelsModel";
import { GameLayers } from "../enums/GameLayers";

export default class BURCascadeReelGroup extends CascadeReelGroup {
    private lockAnimations: SpineAnimation[] = [];
    private spinePool = new Map<string, SpineAnimation[]>();
    private energyChargePositions = new Map(
        [
            { x: 0, y: 0, index: 1 },
            { x: 1, y: 0, index: 2 },
            { x: 2, y: 0, index: 3 },
            { x: 3, y: 0, index: 4 },
            { x: 4, y: 0, index: 5 },
            { x: 5, y: 0, index: 6 },
            { x: 0, y: 1, index: 7 },
            { x: 1, y: 1, index: 8 },
            { x: 2, y: 1, index: 9 },
            { x: 3, y: 1, index: 10 },
            { x: 4, y: 1, index: 11 },
            { x: 5, y: 1, index: 12 },
            { x: 0, y: 2, index: 13 },
            { x: 1, y: 2, index: 14 },
            { x: 2, y: 2, index: 15 },
            { x: 3, y: 2, index: 16 },
            { x: 4, y: 2, index: 17 },
            { x: 5, y: 2, index: 18 },
            { x: 0, y: 3, index: 19 },
            { x: 1, y: 3, index: 20 },
            { x: 2, y: 3, index: 21 },
            { x: 3, y: 3, index: 22 },
            { x: 4, y: 3, index: 23 },
            { x: 5, y: 3, index: 24 }
        ].map((pos) => [`${pos.x},${pos.y}`, pos])
    );

    public spin(): void {
        super.spin();
        ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .containers.get("reels")!
            .enableMask();
    }

    protected stopReels(delay = 0): void {
        if (this.stoppingStarted) {
            return;
        }
        this.stoppingStarted = true;

        // If there are cascades, the symbols after the mystery flips are in the first cascade
        // Otherwise, they are in the reelFinalSymbols
        const symbols = BURSpinModel.cascades.length
            ? BURSpinModel.cascades[0].gridBefore
            : SpinModel.reelFinalSymbols.get(SpinModel.reelSetIndex)!;

        const stickyWilds = new Set(
            BURFeatureModel.random_wilds_positions.map((w) => `${w.x},${w.y}`)
        );

        // Loop through the reels and stop each
        this.spinners.forEach((spinnerBehavior, reelIdx) => {
            if (this.isRespin && !this.lastRemovedSymbols[reelIdx]) {
                return;
            }

            const reel = this.reels[reelIdx];

            const stopSymbols = SpinModel.reelStopSymbols.get(
                BURReelsModel.reelset_index
            )![reelIdx];

            reel.symbols.forEach((symbol, symbolIndex) => {
                if (!stickyWilds.has(`${reelIdx},${symbolIndex}`)) {
                    (symbol as BURReelSymbol).setIsMystery(
                        stopSymbols[symbolIndex] ===
                            BURReelsModel.mystery_symbol_id ||
                            stopSymbols[symbolIndex] ===
                                BURReelsModel.fs_mystery_symbol_id
                    );
                }
            });
            reel.once(
                GameEvents.REEL_STOPPED,
                () => this.onReelStopped(reelIdx),
                this
            );

            // Put a delay between reel stops - grows for each reel
            if (reelIdx !== 0) {
                if (GameModel.turboSpin) {
                    delay +=
                        Configs.reels!.cascadeProps.mainSpinProps
                            .stopReelDelayInTurboMode;
                } else {
                    delay +=
                        Configs.reels!.cascadeProps.mainSpinProps.stopReelDelay;
                }
            }

            spinnerBehavior.animationStartDelay = delay;

            // Then stop the reel
            spinnerBehavior.stop(symbols[reelIdx], false);
        });

        // Notify that reel stopping has started
        this.dispatcher.emit(GameEvents.REEL_STOP_STARTED);

        // End the cascade flag
        this.inCascade = false;
    }

    public hideLinesAndInfo(hideSymbols = false) {
        if (hideSymbols) {
            this.stopSymbolAnimations();
        }
        if (this.winSound) {
            SoundController.stopSound(this.winSound);
        }
        this.winlinesView.hideLines();
        this.clearWinInfoLabel();

        // Trail logic code
        Tween.killDelayedCallsTo(this.runTrail);
        Tween.killDelayedCallsTo(this.runMultiTrail);

        this.tweenInstances.forEach((call) => {
            call.kill();
            //@ts-ignore
            call = null;
        });

        for (let reelIdx = 0; reelIdx < this.reels.length; reelIdx++) {
            for (
                let symIdx = 0;
                symIdx <
                this.reels[reelIdx].symbols.length -
                    2 * GameModel.gameConfig.reelExtraSymbols;
                symIdx++
            ) {
                let symbol = this.getSymbolAt(reelIdx, symIdx);
                // let anim = this.winSymbolsView.getAnimAtReelCell(
                //     reelIdx,
                //     symIdx
                // );

                symbol.alpha = 1;
                // anim.alpha = 1;
            }
        }

        // this.winSymbolsView.removeChildren();

        this.tweenInstances = [];
        // End of trail logic code
    }

    /**
     * Creates the symbol destruction animations ahead of time, enough for every visible symbol to be removed at once,
     * so the first cascades don't have to build them.
     */
    public prewarmSpinePool() {
        const visibleSymbols = this.reels.reduce(
            (count, reel) =>
                count +
                reel.symbols.length -
                2 * GameModel.gameConfig.reelExtraSymbols,
            0
        );
        const free = this.spinePool.get("symbolDestruction") ?? [];
        while (free.length < visibleSymbols) {
            free.push(this.assets.getSpineAnimation("symbolDestruction"));
        }
        this.spinePool.set("symbolDestruction", free);
    }

    /**
     * Gets a spine animation from the pool, or creates one if there is none free.
     * Creating a spine animation is expensive, so the ones used for the symbol effects are reused.
     */
    private acquireSpine(animName: string): SpineAnimation {
        return (
            this.spinePool.get(animName)?.pop() ??
            this.assets.getSpineAnimation(animName)
        );
    }

    /**
     * Takes a finished spine animation off the reels and returns it to the pool
     */
    private releaseSpine(animName: string, anim: SpineAnimation) {
        this.symContainer.removeChild(anim);

        const free = this.spinePool.get(animName);
        if (free) {
            free.push(anim);
        } else {
            this.spinePool.set(animName, [anim]);
        }
    }

    public async destroyWinningSymbol(pos: PointLike) {
        const destructionAnim = this.acquireSpine("symbolDestruction");

        const sbl = this.getSymbolAt(pos.x, pos.y);

        destructionAnim
            .setTransform(sbl.x, sbl.y)
            .scale.set(sbl.spineAnim.scale.x, sbl.spineAnim.scale.y);

        const listener: IAnimationStateListener = {
            event(_, event) {
                if (event.data.name === "transform") {
                    sbl.y = -sbl.height;
                }
            }
        };

        destructionAnim.state.addListener(listener);

        this.symContainer.addChild(destructionAnim);

        await destructionAnim.playAsync();

        destructionAnim.state.removeListener(listener);

        this.releaseSpine("symbolDestruction", destructionAnim);
    }

    /**
     * Energy charge feature - coins fill the meters with energy charge animation
     */
    public async playEnergyCharge(mysteryFlips = false) {
        const energyCharge = ViewManager.getLayer(GameLayers.EnergyCharge)
            .getCurrentScene()
            .spineAnimations.get("energy")!;
        energyCharge.visible = true;

        const coins = mysteryFlips
            ? BURFeatureModel.mystery_energy_coins
            : BURFeatureModel.energy_coins;

        for (let coin of coins) {
            // Play the energy charge animation
            const animName = `cell_${
                this.energyChargePositions.get(`${coin.x},${coin.y}`)!.index
            }`;
            energyCharge.setAnimationSkin(`energy_${coin.color.toLowerCase()}`);
            await energyCharge.playAsync(animName, 1.5, false);

            const affectsMeter = coin.affectsMeter || coin.color === "Yellow";

            // Fill the meter
            if (affectsMeter) {
                await BURReelsModel.energy_meters.collectCoin(coin.color);
            }
        }

        let stopSymbols = SpinModel.reelStopSymbols.get(
            SpinModel.reelSetIndex
        )!;

        await Promise.all(
            coins.map(async (coin) => {
                await this.transformEnergyCoin(
                    { x: coin.x, y: coin.y },
                    mysteryFlips
                        ? BURFeatureModel.mystery_coin_flip_id
                        : stopSymbols[coin.x][coin.y]
                );
            })
        );
    }

    /**
     * Transforms an energy coin into a regular symbol
     * @param pos coin position on the reels
     * @param newId the symbol that the coin will transform into
     */
    private async transformEnergyCoin(pos: PointLike, newId: number) {
        const destructionAnim = this.acquireSpine("symbolDestruction");

        const sbl = this.getSymbolAt(pos.x, pos.y) as BURReelSymbol;

        destructionAnim
            .setTransform(sbl.x, sbl.y)
            .scale.set(sbl.spineAnim.scale.x, sbl.spineAnim.scale.y);

        const isMystery =
            newId === BURReelsModel.mystery_symbol_id ||
            newId === BURReelsModel.fs_mystery_symbol_id;

        const listener: IAnimationStateListener = {
            event(_, event) {
                if (event.data.name === "transform") {
                    sbl.setIsMystery(isMystery);
                    sbl.setId(newId);

                    if (isMystery) {
                        // Don't play the mystery idle animation because when the reels stop
                        // the transition from idle to transform is rough
                        sbl.spineAnim.state.tracks[0].timeScale = 0;
                    }
                }
            }
        };

        destructionAnim.state.addListener(listener);

        this.symContainer.addChild(destructionAnim);

        await destructionAnim.playAsync();

        destructionAnim.state.removeListener(listener);

        this.releaseSpine("symbolDestruction", destructionAnim);
    }

    /**
     * Transforms a jackpot fragment into a regular symbol
     * @param pos fragment position on the reels
     * @param newId the symbol that the coin will transform into
     */
    public async transformJackpotFragment(pos: PointLike, newId: number) {
        const destructionAnim = this.acquireSpine("symbolDestruction");

        const sbl = this.getSymbolAt(pos.x, pos.y) as BURReelSymbol;

        destructionAnim
            .setTransform(sbl.x, sbl.y)
            .scale.set(sbl.spineAnim.scale.x, sbl.spineAnim.scale.y);

        const listener: IAnimationStateListener = {
            event(_, event) {
                if (event.data.name === "transform") {
                    sbl.setIsMystery(false);
                    sbl.setId(newId);
                }
            }
        };

        destructionAnim.state.addListener(listener);

        this.symContainer.addChild(destructionAnim);

        await destructionAnim.playAsync();

        destructionAnim.state.removeListener(listener);

        this.releaseSpine("symbolDestruction", destructionAnim);
    }

    /**
     * Available in Red free spins - transforms any symbol into wild and locks it on the reel
     * @param pos position of the symbol on the reels
     */
    public async transformSymbolToWild(pos: PointLike) {
        // Play the energy frame lock anim
        const energyFrameAnim = this.acquireSpine("energyFrame");

        const sbl = this.getSymbolAt(pos.x, pos.y) as BURReelSymbol;

        energyFrameAnim
            .setTransform(sbl.x, sbl.y)
            .scale.set(sbl.spineAnim.scale.x, sbl.spineAnim.scale.y);

        this.symContainer.addChild(energyFrameAnim);
        this.lockAnimations.push(energyFrameAnim);

        await energyFrameAnim.playAsync();
        energyFrameAnim.play("Idle", true);

        // If the symbol is not wild already, transform it to wild
        const wildId = BURReelsModel.wild_id;
        if (sbl.getId() !== wildId) {
            const transformAnim = this.acquireSpine("transformWild");

            transformAnim
                .setTransform(sbl.x, sbl.y)
                .scale.set(sbl.spineAnim.scale.x, sbl.spineAnim.scale.y);

            const listener: IAnimationStateListener = {
                event(_, event) {
                    if (event.data.name === "Transform") {
                        sbl.setIsMystery(false);
                        sbl.setId(wildId);
                    }
                }
            };

            transformAnim.state.addListener(listener);

            this.symContainer.addChild(transformAnim);

            await transformAnim.playAsync();

            transformAnim.state.removeListener(listener);

            this.releaseSpine("transformWild", transformAnim);
        }
    }

    /**
     * Available in Red free spins - removes the energy frames around the locked wilds
     */
    public async removeEnergyFrames() {
        if (!this.lockAnimations.length) return;

        await Promise.all(
            this.lockAnimations.map(async (anim) => {
                await anim.playAsync("end").then(() => {
                    this.releaseSpine("energyFrame", anim);
                });
            })
        );
        this.lockAnimations = [];
    }

    /**
     * Transforms a mystery symbol into a regular symbol
     * @param pos mystery symbol position on the reels
     */
    public async transformMysterySymbol(pos: PointLike) {
        const sbl = this.getSymbolAt(pos.x, pos.y) as BURReelSymbol;

        // If the mystery should transform into an energy coin first, change the id
        const coin = BURFeatureModel.mystery_energy_coins.find(
            (coin) => coin.x === pos.x && coin.y === pos.y
        );
        if (coin) {
            const symbolId = sbl.getId();
            sbl.setId(BURReelsModel.energy_coin_ids.get(coin.color)!);
            BURFeatureModel.setMysteryCoinFlipId(symbolId);
        }

        // Play the transform animation
        await sbl.playAsyncSpineAnim("transform");
        sbl.playSpineAnim("idle");
    }
}
